export default __webpack_public_path__ + "static/media/background.cdf52d22.jpg";